
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const InvoicingType = {
  PERSONAL: 'PERSONAL',
  COMPANY: 'COMPANY'
} as const

export type InvoicingType = (typeof InvoicingType)[keyof typeof InvoicingType]


export const PlatformMenuVariant = {
  STANDARD: 'STANDARD',
  ONLY_FREIGHT: 'ONLY_FREIGHT'
} as const

export type PlatformMenuVariant = (typeof PlatformMenuVariant)[keyof typeof PlatformMenuVariant]


export const SubscriptionRequestStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED'
} as const

export type SubscriptionRequestStatus = (typeof SubscriptionRequestStatus)[keyof typeof SubscriptionRequestStatus]


export const SubscriptionLimitUnit = {
  DAYS: 'DAYS',
  WEEKS: 'WEEKS',
  MONTHS: 'MONTHS',
  COUNT: 'COUNT'
} as const

export type SubscriptionLimitUnit = (typeof SubscriptionLimitUnit)[keyof typeof SubscriptionLimitUnit]


export const LimitableFeature = {
  FREIGHT_CALCULATOR_HISTORICAL_MONTHS: 'FREIGHT_CALCULATOR_HISTORICAL_MONTHS',
  FREIGHT_CALCULATOR_HISTORICAL_WEEKS: 'FREIGHT_CALCULATOR_HISTORICAL_WEEKS',
  FREIGHT_CALCULATOR_HISTORICAL_DAYS: 'FREIGHT_CALCULATOR_HISTORICAL_DAYS'
} as const

export type LimitableFeature = (typeof LimitableFeature)[keyof typeof LimitableFeature]


export const PermissionInternal = {
  BROKER_PORTAL: 'BROKER_PORTAL',
  SALES_PORTAL: 'SALES_PORTAL',
  RESEARCH_PORTAL: 'RESEARCH_PORTAL',
  NOMINAL_PRICES_UPLOAD: 'NOMINAL_PRICES_UPLOAD',
  MARKET_EVENTS_INPUT: 'MARKET_EVENTS_INPUT',
  MARKET_COMMENTARY_INPUT: 'MARKET_COMMENTARY_INPUT',
  NEWS_INPUT: 'NEWS_INPUT',
  LINEUP_INPUT: 'LINEUP_INPUT',
  FREIGHT_QUOTE_REQUESTS: 'FREIGHT_QUOTE_REQUESTS',
  DATA_SERIES_OVERVIEW: 'DATA_SERIES_OVERVIEW',
  EXPORT_MARKETING_REPORTS_PREVIEW: 'EXPORT_MARKETING_REPORTS_PREVIEW',
  LINEUP_STRING_READ: 'LINEUP_STRING_READ',
  PAYLOAD_ADMIN_PANEL: 'PAYLOAD_ADMIN_PANEL',
  SUPPLY_DEMAND_BACKOFFICE: 'SUPPLY_DEMAND_BACKOFFICE'
} as const

export type PermissionInternal = (typeof PermissionInternal)[keyof typeof PermissionInternal]


export const UserRole = {
  ADMIN: 'ADMIN',
  SALESPERSON: 'SALESPERSON',
  RESEARCHER: 'RESEARCHER',
  BROKER: 'BROKER',
  CM_USER: 'CM_USER',
  USER: 'USER'
} as const

export type UserRole = (typeof UserRole)[keyof typeof UserRole]


export const TeamRole = {
  OWNER: 'OWNER',
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER'
} as const

export type TeamRole = (typeof TeamRole)[keyof typeof TeamRole]


export const OnboardingStatus = {
  STATE_ZERO: 'STATE_ZERO',
  ACCOUNT_CREATED: 'ACCOUNT_CREATED',
  DETAILS_SUBMITTED: 'DETAILS_SUBMITTED',
  EMAIL_VERIFIED: 'EMAIL_VERIFIED',
  COMPLETED: 'COMPLETED'
} as const

export type OnboardingStatus = (typeof OnboardingStatus)[keyof typeof OnboardingStatus]


export const InvitationStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  EXPIRED: 'EXPIRED'
} as const

export type InvitationStatus = (typeof InvitationStatus)[keyof typeof InvitationStatus]


export const ApprovalStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED'
} as const

export type ApprovalStatus = (typeof ApprovalStatus)[keyof typeof ApprovalStatus]


export const LeadSource = {
  UNKNOWN: 'UNKNOWN',
  CONFERENCE: 'CONFERENCE',
  SEARCH_ENGINES: 'SEARCH_ENGINES',
  CM_GROUP: 'CM_GROUP',
  LINKEDIN: 'LINKEDIN',
  EMAIL_MARKETING: 'EMAIL_MARKETING',
  AG_RESOURCE_PARTNER_PROGRAM: 'AG_RESOURCE_PARTNER_PROGRAM',
  OTHER: 'OTHER'
} as const

export type LeadSource = (typeof LeadSource)[keyof typeof LeadSource]


export const PermissionLevel = {
  VIEW: 'VIEW',
  WRITE: 'WRITE',
  FULL: 'FULL'
} as const

export type PermissionLevel = (typeof PermissionLevel)[keyof typeof PermissionLevel]


export const PermissionType = {
  MODULE: 'MODULE',
  ENTITY: 'ENTITY',
  PAGE: 'PAGE',
  EMAIL_REPORT: 'EMAIL_REPORT'
} as const

export type PermissionType = (typeof PermissionType)[keyof typeof PermissionType]


export const PermissionStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  EXPIRED: 'EXPIRED',
  UPCOMING: 'UPCOMING',
  CANCELLED: 'CANCELLED'
} as const

export type PermissionStatus = (typeof PermissionStatus)[keyof typeof PermissionStatus]


export const CRMDepartment = {
  NGO_GOVERNMENT: 'NGO_GOVERNMENT',
  PHYSICAL_TRADING: 'PHYSICAL_TRADING',
  FINANCE: 'FINANCE',
  LOGISTICS: 'LOGISTICS'
} as const

export type CRMDepartment = (typeof CRMDepartment)[keyof typeof CRMDepartment]


export const CRMRiskProfile = {
  CONSERVATIVE: 'CONSERVATIVE',
  MODERATE: 'MODERATE',
  AGGRESSIVE: 'AGGRESSIVE'
} as const

export type CRMRiskProfile = (typeof CRMRiskProfile)[keyof typeof CRMRiskProfile]


export const CRMChurnRisk = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  VERY_HIGH: 'VERY_HIGH'
} as const

export type CRMChurnRisk = (typeof CRMChurnRisk)[keyof typeof CRMChurnRisk]


export const UserOrigin = {
  WEBSITE: 'WEBSITE',
  SALES: 'SALES',
  MARKETING: 'MARKETING',
  REFERRAL: 'REFERRAL'
} as const

export type UserOrigin = (typeof UserOrigin)[keyof typeof UserOrigin]


export const CRMBusinessSector = {
  AGRICULTURE: 'AGRICULTURE',
  ENERGY: 'ENERGY',
  METALS: 'METALS',
  MINERALS: 'MINERALS',
  FREIGHT: 'FREIGHT',
  CUSTOMS: 'CUSTOMS'
} as const

export type CRMBusinessSector = (typeof CRMBusinessSector)[keyof typeof CRMBusinessSector]


export const CRMOpportunityStatus = {
  QUALIFY: 'QUALIFY',
  DEVELOP: 'DEVELOP',
  DEMONSTRATE: 'DEMONSTRATE',
  CHASE: 'CHASE',
  EXECUTION: 'EXECUTION',
  CLOSED: 'CLOSED',
  LOST: 'LOST'
} as const

export type CRMOpportunityStatus = (typeof CRMOpportunityStatus)[keyof typeof CRMOpportunityStatus]


export const SubscriptionRenewalStatus = {
  PENDING: 'PENDING',
  NEGOTIATION: 'NEGOTIATION',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED'
} as const

export type SubscriptionRenewalStatus = (typeof SubscriptionRenewalStatus)[keyof typeof SubscriptionRenewalStatus]


export const InvoiceStatus = {
  PENDING: 'PENDING',
  PAID: 'PAID',
  OVERDUE: 'OVERDUE',
  CANCELLED: 'CANCELLED'
} as const

export type InvoiceStatus = (typeof InvoiceStatus)[keyof typeof InvoiceStatus]


export const UserEventType = {
  SIGNUP: 'SIGNUP',
  DETAILS_SUBMITTED: 'DETAILS_SUBMITTED',
  REQUEST_TRIAL: 'REQUEST_TRIAL',
  APPROVE_TRIAL: 'APPROVE_TRIAL',
  REJECT_TRIAL: 'REJECT_TRIAL',
  CANCEL_TRIAL: 'CANCEL_TRIAL',
  EXTEND_TRIAL: 'EXTEND_TRIAL',
  EXPIRED_TRIAL: 'EXPIRED_TRIAL',
  REQUEST_DEMO: 'REQUEST_DEMO',
  TRIAL: 'TRIAL',
  INVITATION: 'INVITATION',
  ACCOUNT_DETAILS: 'ACCOUNT_DETAILS',
  OPPORTUNITY_STATUS_CHANGED: 'OPPORTUNITY_STATUS_CHANGED',
  EMAIL_VERIFIED: 'EMAIL_VERIFIED',
  ASSIGNED_TO_SUBSCRIPTION_INSTANCE: 'ASSIGNED_TO_SUBSCRIPTION_INSTANCE',
  REMOVED_FROM_SUBSCRIPTION_INSTANCE: 'REMOVED_FROM_SUBSCRIPTION_INSTANCE',
  ADDED_TO_MARKET_REPORT_SUBSCRIPTION: 'ADDED_TO_MARKET_REPORT_SUBSCRIPTION',
  REMOVED_FROM_MARKET_REPORT_SUBSCRIPTION: 'REMOVED_FROM_MARKET_REPORT_SUBSCRIPTION',
  SWITCHED_TEAM: 'SWITCHED_TEAM',
  ACCEPTED_INVITATION: 'ACCEPTED_INVITATION'
} as const

export type UserEventType = (typeof UserEventType)[keyof typeof UserEventType]


export const ProteinUnitRegion = {
  EU: 'EU',
  US: 'US'
} as const

export type ProteinUnitRegion = (typeof ProteinUnitRegion)[keyof typeof ProteinUnitRegion]


export const MarketReportInterval = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  YEARLY: 'YEARLY'
} as const

export type MarketReportInterval = (typeof MarketReportInterval)[keyof typeof MarketReportInterval]


export const PublicationStatus = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  ARCHIVED: 'ARCHIVED'
} as const

export type PublicationStatus = (typeof PublicationStatus)[keyof typeof PublicationStatus]


export const PublicationVisibility = {
  EXTERNAL: 'EXTERNAL',
  INTERNAL: 'INTERNAL',
  PRIVATE: 'PRIVATE'
} as const

export type PublicationVisibility = (typeof PublicationVisibility)[keyof typeof PublicationVisibility]


export const BidOfferConfidential = {
  PRICE: 'PRICE',
  CLIENT: 'CLIENT'
} as const

export type BidOfferConfidential = (typeof BidOfferConfidential)[keyof typeof BidOfferConfidential]


export const BidOfferType = {
  BID: 'BID',
  OFFER: 'OFFER'
} as const

export type BidOfferType = (typeof BidOfferType)[keyof typeof BidOfferType]


export const MeasurementUnitType = {
  VOLUME: 'VOLUME',
  WEIGHT: 'WEIGHT',
  LENGTH: 'LENGTH',
  TIME: 'TIME',
  AREA: 'AREA'
} as const

export type MeasurementUnitType = (typeof MeasurementUnitType)[keyof typeof MeasurementUnitType]


export const PriceType = {
  FLAT: 'FLAT',
  PREMIUM: 'PREMIUM'
} as const

export type PriceType = (typeof PriceType)[keyof typeof PriceType]


export const Firmness = {
  INTEREST: 'INTEREST',
  QUOTE: 'QUOTE',
  FIRM: 'FIRM'
} as const

export type Firmness = (typeof Firmness)[keyof typeof Firmness]


export const BidOfferCloseReason = {
  AUTO_EXPIRATION: 'AUTO_EXPIRATION',
  CLOSED: 'CLOSED',
  CLOSED_TRADED_BY_CM: 'CLOSED_TRADED_BY_CM',
  CLOSED_TRADED_BY_COMPETITION: 'CLOSED_TRADED_BY_COMPETITION',
  CLOSED_WITHDRAWN_BY_CLIENT: 'CLOSED_WITHDRAWN_BY_CLIENT'
} as const

export type BidOfferCloseReason = (typeof BidOfferCloseReason)[keyof typeof BidOfferCloseReason]


export const PriceScope = {
  INTERNAL: 'INTERNAL',
  EXTERNAL: 'EXTERNAL'
} as const

export type PriceScope = (typeof PriceScope)[keyof typeof PriceScope]


export const FreightQuoteStatus = {
  NEW: 'NEW',
  IN_PROGRESS: 'IN_PROGRESS',
  BOOKED: 'BOOKED',
  NOT_BOOKED: 'NOT_BOOKED',
  CLOSED: 'CLOSED'
} as const

export type FreightQuoteStatus = (typeof FreightQuoteStatus)[keyof typeof FreightQuoteStatus]


export const FreightQuoteRequestGranularity = {
  month: 'month',
  week: 'week',
  day: 'day'
} as const

export type FreightQuoteRequestGranularity = (typeof FreightQuoteRequestGranularity)[keyof typeof FreightQuoteRequestGranularity]


export const FreightCalculatorCalculationContext = {
  Spot: 'Spot',
  Historical: 'Historical'
} as const

export type FreightCalculatorCalculationContext = (typeof FreightCalculatorCalculationContext)[keyof typeof FreightCalculatorCalculationContext]


export const FreightCalculatorVesselSize = {
  Coaster: 'Coaster',
  Large_Coaster: 'Large_Coaster',
  Capesize: 'Capesize',
  MiniBulk: 'MiniBulk',
  Smallhandy: 'Smallhandy',
  Handysize: 'Handysize',
  Supramax: 'Supramax',
  Ultramax: 'Ultramax',
  Panamax: 'Panamax',
  Kamsarmax: 'Kamsarmax'
} as const

export type FreightCalculatorVesselSize = (typeof FreightCalculatorVesselSize)[keyof typeof FreightCalculatorVesselSize]


export const StowageFactorUnit = {
  CBFT: 'CBFT',
  KGHL: 'KGHL'
} as const

export type StowageFactorUnit = (typeof StowageFactorUnit)[keyof typeof StowageFactorUnit]


export const CadenceInputType = {
  MTS_DAY: 'MTS_DAY',
  HOURS: 'HOURS'
} as const

export type CadenceInputType = (typeof CadenceInputType)[keyof typeof CadenceInputType]


export const MatrixAlgorithmGroup = {
  ExactMatch: 'ExactMatch',
  CommodityInPort: 'CommodityInPort',
  Force: 'Force'
} as const

export type MatrixAlgorithmGroup = (typeof MatrixAlgorithmGroup)[keyof typeof MatrixAlgorithmGroup]


export const FreightMatrixViewMode = {
  CARTESIAN: 'CARTESIAN',
  ONE_TO_ONE: 'ONE_TO_ONE'
} as const

export type FreightMatrixViewMode = (typeof FreightMatrixViewMode)[keyof typeof FreightMatrixViewMode]


export const NotificationChannelPlatform = {
  WHATSAPP: 'WHATSAPP',
  EMAIL: 'EMAIL',
  PLATFORM: 'PLATFORM'
} as const

export type NotificationChannelPlatform = (typeof NotificationChannelPlatform)[keyof typeof NotificationChannelPlatform]


export const WhiteBlackListType = {
  WHITELIST: 'WHITELIST',
  BLACKLIST: 'BLACKLIST'
} as const

export type WhiteBlackListType = (typeof WhiteBlackListType)[keyof typeof WhiteBlackListType]


export const WhiteBlackListValueType = {
  LocationCollection: 'LocationCollection',
  LocationCollectionList: 'LocationCollectionList',
  BasePortInstance: 'BasePortInstance',
  FutureContractInstance: 'FutureContractInstance',
  MeasurementUnit: 'MeasurementUnit',
  IncoParity: 'IncoParity',
  ProductHierachyInstance: 'ProductHierachyInstance',
  ProductHierachy: 'ProductHierachy',
  DocumentRequirement: 'DocumentRequirement',
  Currency: 'Currency',
  Product: 'Product',
  ExchangeMarket: 'ExchangeMarket',
  Port: 'Port',
  Country: 'Country',
  QualityRequirement: 'QualityRequirement'
} as const

export type WhiteBlackListValueType = (typeof WhiteBlackListValueType)[keyof typeof WhiteBlackListValueType]


export const LineupStatus = {
  Awaited: 'Awaited',
  Loading: 'Loading',
  Waiting: 'Waiting',
  Sailed: 'Sailed',
  Discharging: 'Discharging',
  Discharged: 'Discharged'
} as const

export type LineupStatus = (typeof LineupStatus)[keyof typeof LineupStatus]


export const BillingInterval = {
  MONTHLY: 'MONTHLY'
} as const

export type BillingInterval = (typeof BillingInterval)[keyof typeof BillingInterval]


export const CurrencyCode = {
  EUR: 'EUR',
  USD: 'USD'
} as const

export type CurrencyCode = (typeof CurrencyCode)[keyof typeof CurrencyCode]


export const PaymentProvider = {
  STRIPE: 'STRIPE',
  TEST: 'TEST'
} as const

export type PaymentProvider = (typeof PaymentProvider)[keyof typeof PaymentProvider]


export const PaymentProductType = {
  MARKET_REPORT_GROUP: 'MARKET_REPORT_GROUP',
  PLATFORM: 'PLATFORM'
} as const

export type PaymentProductType = (typeof PaymentProductType)[keyof typeof PaymentProductType]


export const SelfCheckoutSubscriptionStatus = {
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  PAST_DUE: 'PAST_DUE',
  CANCELED: 'CANCELED',
  EXPIRED: 'EXPIRED',
  PAUSED: 'PAUSED',
  TRIALING: 'TRIALING'
} as const

export type SelfCheckoutSubscriptionStatus = (typeof SelfCheckoutSubscriptionStatus)[keyof typeof SelfCheckoutSubscriptionStatus]


export const SelfCheckoutSubscriptionType = {
  SINGLE_GROUP: 'SINGLE_GROUP',
  MULTIPLE_GROUPS: 'MULTIPLE_GROUPS',
  PLATFORM: 'PLATFORM'
} as const

export type SelfCheckoutSubscriptionType = (typeof SelfCheckoutSubscriptionType)[keyof typeof SelfCheckoutSubscriptionType]


export const SubscriptionChangeType = {
  CREATED: 'CREATED',
  UPGRADE: 'UPGRADE',
  DOWNGRADE: 'DOWNGRADE',
  RENEWED: 'RENEWED',
  CANCELED: 'CANCELED',
  REACTIVATED: 'REACTIVATED',
  PAUSED: 'PAUSED',
  RESUMED: 'RESUMED'
} as const

export type SubscriptionChangeType = (typeof SubscriptionChangeType)[keyof typeof SubscriptionChangeType]


export const WebhookEventStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  PROCESSED: 'PROCESSED',
  FAILED: 'FAILED',
  IGNORED: 'IGNORED'
} as const

export type WebhookEventStatus = (typeof WebhookEventStatus)[keyof typeof WebhookEventStatus]


export const SupplyDemandAttributeName = {
  AREA: 'AREA',
  CARRY_IN: 'CARRY_IN',
  CARRY_OUT: 'CARRY_OUT',
  CRUSH: 'CRUSH',
  FEED_GRAIN: 'FEED_GRAIN',
  FEED_OILSEED: 'FEED_OILSEED',
  INDUSTRIAL_GRAIN: 'INDUSTRIAL_GRAIN',
  INDUSTRIAL_OILSEED: 'INDUSTRIAL_OILSEED',
  PRODUCTION: 'PRODUCTION',
  SEEDS_WASTE: 'SEEDS_WASTE',
  YIELD_MT_HA: 'YIELD_MT_HA',
  IMPORTS: 'IMPORTS',
  EXPORTS: 'EXPORTS',
  IMPORTS_INTRA_EU: 'IMPORTS_INTRA_EU',
  IMPORTS_EXTRA_EU: 'IMPORTS_EXTRA_EU',
  EXPORTS_INTRA_EU: 'EXPORTS_INTRA_EU',
  EXPORTS_EXTRA_EU: 'EXPORTS_EXTRA_EU'
} as const

export type SupplyDemandAttributeName = (typeof SupplyDemandAttributeName)[keyof typeof SupplyDemandAttributeName]


export const SupplyDemandAttributeCountryGroup = {
  BOTH: 'BOTH',
  EU: 'EU',
  MAJORS: 'MAJORS'
} as const

export type SupplyDemandAttributeCountryGroup = (typeof SupplyDemandAttributeCountryGroup)[keyof typeof SupplyDemandAttributeCountryGroup]
